import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    fullName,
    chiefAccountant,
    accountingServices,
    signer,
    certificate,
    timeSign,

    taxpayersName,
    taxpayersId,

    unit,
    bctc,
    htldl,
    auditOpinion,
  },
} = checkout;

const validation = Yup.object().shape({
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [chiefAccountant.name]: Yup.string().required(chiefAccountant.errorMsg),
  [accountingServices.name]: Yup.string().required(accountingServices.errorMsg),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [bctc.name]: Yup.string().required(bctc.errorMsg),
  [htldl.name]: Yup.string().required(htldl.errorMsg),
  [taxpayersName.name]: Yup.string().required(taxpayersName.errorMsg),
  [auditOpinion.name]: Yup.string().required(auditOpinion.errorMsg),
  [unit.name]: Yup.string().required(unit.errorMsg),

  [timeSign.name]: Yup.number().required(timeSign.errorMsg),

  [taxpayersId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxpayersId.invalidMsg)
    .required(taxpayersId.errorMsg),
});

export default validation;
